import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid, Box, useMediaQuery, useTheme } from '@material-ui/core';
import { translate } from 'helpers/intl';
import messages from 'containers/AutoDetailsPage/messages';
import { sanlamVeryDarkBlue } from 'Material-UI/colors';
import { SizedSmallSectionHeader } from 'containers/AutoDetailsPage/MyContractAndGarantiesTab/KnowMoreAboutContracts/styles';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';

const KnowMoreAboutContracts = (props: { intl: IntlShape }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  return (
    <GaLoadHOC
      category={EVENT_CATEGORIES.MRH_DETAILS}
      label="Mes contrats_Tab 2_Mes contrats"
    >
      <Box marginBottom={1.25}>
        <Grid justify="space-between" alignItems="center" container>
          <Grid item xs={matches ? 12 : 5}>
            <SizedSmallSectionHeader color={sanlamVeryDarkBlue} weight="bold">
              {translate({ ...messages.FindMoreAboutContracts }, props)}
            </SizedSmallSectionHeader>
          </Grid>
        </Grid>
      </Box>
    </GaLoadHOC>
  );
};

export default injectIntl(KnowMoreAboutContracts);

export const TestKnowMoreAboutContracts = injectIntl(KnowMoreAboutContracts);
